import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { compose } from "redux";
import { connect } from "react-redux";
import {
  selectHasAddress,
  saveAddress_Begin,
  getCities,
  getTowns,
  sendSmsOfferValidation,
  checkIfCustomerHasAddress_Begin
} from "../../../state/ducks/calculation/index";
import NumberFormat from "react-number-format";
import $ from "jquery";
import AppCustomSelect from "../shared/AppCustomSelect";
import {
  getCustomSelectLabel,
  getCustomSelectValue,
  setCustomSelectFieldState,
} from "../../../utils/customSelect";

function formKontrol() {
  var il = getCustomSelectLabel("cityId");
  var ilce = getCustomSelectLabel("townId");
  var semt = $("#district").val();
  var cadde = $("#avenue").val();
  var sokak = $("#street").val();
  var kapi = $("#doorNumber").val();
  var posta = $("#postCode").val();
  var durum = 1;

  // il seçili mi ?
  if (il == "İl Seçiniz" || getCustomSelectValue("cityId") === "") {
      durum = 0;
      setCustomSelectFieldState("cityId", true);
      $("#cityId_hatamesaj").html("Bu alan boş bırakılamaz");
  } else {
      setCustomSelectFieldState("cityId", false);
      $("#cityId_hatamesaj").html("");
  }
  if (ilce == "İlçenizi Seçiniz" || getCustomSelectValue("townId") === "") {
      durum = 0;
      setCustomSelectFieldState("townId", true);
      $("#townId_hatamesaj").html("bu alan boş bırakılamaz");
  } else {
      setCustomSelectFieldState("townId", false);
      $("#townId_hatamesaj").html("");
  }
  // Semt Alanı boş mu kontrol
  if (semt == "") {
      durum = 0; 
      $("#district").parent().addClass("t-error");
      $("#district").next().html("<i class='t-icon-error text-danger'></i>");
      $("#district_hatamesaj").html("Bu alan boş bırakılamaz");
  } else {
      $("#district").parent().removeClass("t-error");
      $("#district").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#district_hatamesaj").html("");
  }
  // Cadde boş mu kontrol
  if (cadde == "") {
      durum = 0; 
      $("#avenue").parent().addClass("t-error");
      $("#avenue").next().html("<i class='t-icon-error text-danger'></i>");
      $("#avenue_hatamesaj").html("Bu alan boş bırakılamaz");
  } else {
      $("#avenue").parent().removeClass("t-error");
      $("#avenue").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#avenue_hatamesaj").html("");
  }
  // Sokak boş mu kontrol
  if (sokak == "") {
      durum = 0; 
      $("#street").parent().addClass("t-error");
      $("#street").next().html("<i class='t-icon-error text-danger'></i>");
      $("#street_hatamesaj").html("Bu alan boş bırakılamaz");
  } else {
      $("#street").parent().removeClass("t-error");
      $("#street").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#street_hatamesaj").html("");
  }
  // Kapı boş mu kontrol
  if (kapi == "") {
      durum = 0; 
      $("#doorNumber").parent().addClass("t-error");
      $("#doorNumber").next().html("<i class='t-icon-error text-danger'></i>");
      $("#doorNumber_hatamesaj").html("Bu alan boş bırakılamaz");
  } else {
      $("#doorNumber").parent().removeClass("t-error");
      $("#doorNumber").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#doorNumber_hatamesaj").html("");
  }
  // Posta boş mu kontrol
  if (posta == "") {
      durum = 0; 
      $("#postCode").parent().addClass("t-error");
      $("#postCode").next().html("<i class='t-icon-error text-danger'></i>");
      $("#postCode_hatamesaj").html("Bu alan boş bırakılamaz");
  } else {
      $("#postCode").parent().removeClass("t-error");
      $("#postCode").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#postCode_hatamesaj").html("");
  }
  
  return durum;
  
}
const NewAddress = ({ saveAddress_Begin, history, hasAddress }) => {
  const [state, setstate] = useState({
    cities: [],
    towns: [],
    kartId: "",
    cityId: "",
    townId: "",
    district: "",
    avenue: "",
    street: "",
    doorNumber: "",
    postCode: "",
    cityDisabled: false,
    townDisabled: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    var control = true;
    var postCode = document.getElementById("postCode");

    if (formKontrol()==1) {
      const postData = {
        sehirId: state.cityId,
        ilceId: state.townId,
        semtMahalleAdi: state.district,
        cadde: state.avenue,
        sokak: state.street,
        kapiNo: state.doorNumber,
        postaKodu: state.postCode,
      };

      saveAddress_Begin(postData);

      sendSmsOfferValidation();

      setstate({
        towns: [],
        kartId: "",
        cityId: "",
        townId: "",
        district: "",
        avenue: "",
        street: "",
        doorNumber: "",
        postCode: "",
      });

      history.push("/Home/SmsVerification");
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setstate({ ...state, [name]: value });
  };

  const handleCityChange = (cityId) => {
    getTowns(cityId).then((towns) => {
      setstate((prev) => ({ ...prev, cityId, townId: "", towns }));
    });
  };

  const handleCityLoad = () => {
    if (!hasAddress) {
      history.push("/Home/SmartCalculation");
    }
    getCities().then((cities) => {
      if (hasAddress != null && hasAddress?.sehirId !== 0) {
        const cityId = hasAddress.sehirId.toString();
        getTowns(cityId).then((towns) => {
          const townId =
            hasAddress != null && hasAddress?.ilceId !== 0
              ? hasAddress.ilceId.toString()
              : "";
          setstate((prev) => ({
            ...prev,
            cities,
            cityId,
            towns,
            townId,
            cityDisabled: true,
            townDisabled: hasAddress?.ilceId !== 0,
          }));
        });
      } else {
        setstate((prev) => ({ ...prev, cities }));
      }
    });
  };

  useEffect(() => {
    
    checkIfCustomerHasAddress_Begin();
    handleCityLoad();
    // getCities().then((cities) => {
    //   setstate({ ...state, cities });

    // });
  }, []);

  return (
    <div className="container-fluid">
      {/* yesil Alan*/}
      <div className="row" style={{ padding: "3%" }}>
        <div className="col-12">
          {/* KUTU 1 */}
          <div className="row no-gutters t-kutu t-mavicizgi">
            <div
              className="col bosluk backright"
              style={{
                backgroundImage: 'url("/assets/img/backgrounds/back_right_mavi.jpg")'
              }}
            >
              {/* içerikler */}
              {/* Başlık */}
              <div className="row no-gutters pb-4">
                <div clss="col-auto">
                  <i className="t-icon-document-alt-stroke icon" />
                </div>
                <div className="col d-flex flex-column justify-content-center">
                  <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                    Adres Bilgileri
                  </div>
                  <span className="altBaslik">
                    Oluşturulacak sözleşmenin gönderileceği adresi giriniz.{" "}
                    
                  </span>
                 
                </div>
              </div>
              <div className="row no-gutters">
              <span style={{fontSize:"medium"}}>
                  {hasAddress?.sehirId !== 0 &&
                      " İl/İlçe bilgisini değiştirmek isterseniz Müşteri Temsilcinizle iletişime geçiniz."}
                  </span>
              </div>
              <div className="row no-gutters">
                {/* Şehir*/}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">İl</span>
                </div>
                <div className="col-12">
                  <div className="t-icInput">
                    <div>
                      <i className="t-icon-location1" />
                    </div>
                    <AppCustomSelect
                      id="cityId"
                      value={state.cityId}
                      placeholder="İl Seçiniz"
                      disabled={state.cityDisabled}
                      options={[
                        { value: "", label: "İl Seçiniz" },
                        ...(state.cities?.map((item) => ({
                          value: String(item.id),
                          label: item.adi,
                        })) || []),
                      ]}
                      onChange={handleCityChange}
                    />
                    <div />
                  </div>
                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="cityId_hatamesaj"
                />
                {/* İlçe*/}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">İlçe</span>
                </div>
                <div className="col-12">
                  <div className="t-icInput">
                    <div>
                      <i className="t-icon-location1" />
                    </div>
                    <AppCustomSelect
                      id="townId"
                      value={state.townId}
                      placeholder="İlçenizi Seçiniz"
                      disabled={state.townDisabled}
                      options={[
                        { value: "", label: "İlçenizi Seçiniz" },
                        ...(state.towns?.map((item) => ({
                          value: String(item.id),
                          label: item.adi,
                        })) || []),
                      ]}
                      onChange={(nextValue) => setstate((prev) => ({ ...prev, townId: nextValue }))}
                    />
                    <div />
                  </div>
                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="townId_hatamesaj"
                />
                {/* Semt Mahalle */}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">Semt / Mahalle</span>
                </div>
                <div className="col-12">
                  <div className="t-icInput">
                    <div>
                      <i className="t-icon-location1" />
                    </div>
                    <input
                      type="text"
                      name="district"
                      onChange={handleChange}
                      value={state.district}
                      id="district"
                      placeholder="Semt/Mahalle Adını Yazınız"
                      required
                      maxLength="50"
                    />
                    <div />
                  </div>
                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="district_hatamesaj"
                />
                {/* Cadde */}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">Cadde</span>
                </div>
                <div className="col-12">
                  <div className="t-icInput">
                    <div>
                      <i className="t-icon-location1" />
                    </div>
        
                     <input
                      type="text"
                      name="avenue"
                      id="avenue"
                      className=""
                      onChange={handleChange}
                      value={state.avenue}
                      placeholder="Cadde"
                      maxLength="50"
                    />
                    <div />
                  </div>
                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="avenue_hatamesaj"
                />
                {/* Sokak */}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">Sokak</span>
                </div>
                <div className="col-12">
                  <div className="t-icInput">
                    <div>
                      <i className="t-icon-location1" />
                    </div>
                    <input
                      type="text"
                      id="street"
                      name="street"
                      onChange={handleChange}
                      value={state.street}
                      placeholder="Sokak"
                      maxLength="50"
                    />
                    <div />
                  </div>
                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="street_hatamesaj"
                />
                {/* Kapı No */}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">Kapı No</span>
                </div>
                <div className="col-12">
                  <div className="t-icInput">
                    <div>
                      <i className="t-icon-location1" />
                    </div>
                    <input
                      type="text"
                      id="doorNumber"
                      name="doorNumber"
                      onChange={handleChange}
                      value={state.doorNumber}
                      placeholder="Kapı No"
                      required
                      maxLength="10"
                    />
                    <div />
                  </div>
                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="doorNumber_hatamesaj"
                />
                {/* Posta Kodu */}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">Posta Kodu</span>
                </div>
                <div className="col-12">
                  <div className="t-icInput">
                    <div>
                      <i className="t-icon-tour" />
                    </div>
                    <NumberFormat
                  displayType={"input"}
                  maxLength="5"
                  minLength="5"
                  id="postCode"
                  name="postCode"
                  placeholder="Posta Kodu"
                  value={state.postCode}
                  onChange={handleChange}
                />
                    <div />
                  </div>
                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="postCode_hatamesaj"
                />
                {/* Button */}
                <div className="col-12 d-flex justify-content-center pb-3">
                  <button className="t-icButonMavi" onClick={handleSubmit}>
                    <span>Devam</span>
                    <i className="t-icon-arrow-right2" />
                  </button>
                </div>
              </div>
              {/* içerikler BİTTİ */}
            </div>
            <div className="col-auto renk" />
          </div>
          {/* KUTU 1 BİTTİ */}
        </div>
      </div>
      {/* Duyurlar Baslık*/}
      {/* duyrular Bitti*/}
      <div className="row" style={{ height: 30 }} />
    </div>

  );
};

const mapStateToProps = (state) => ({
  hasAddress: selectHasAddress(state),
  
});

const mapDispatchToProps = (dispatch) => ({
  saveAddress_Begin: (address) => dispatch(saveAddress_Begin(address)),
  checkIfCustomerHasAddress_Begin: () => dispatch(checkIfCustomerHasAddress_Begin()),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(NewAddress);
